var React = require('react');

function ArrowTopLeftBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.55259 2.77198L1.55259 11.2523L-2.32055e-08 11.2523L-5.05632e-07 0.215682L11.4504 0.215682L11.4504 1.71218L2.64875 1.71218L11.9995 10.725L10.9016 11.7832L1.55259 2.77198Z","fill":"#101010"}));
}

ArrowTopLeftBlack.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowTopLeftBlack;

ArrowTopLeftBlack.default = ArrowTopLeftBlack;
